import { isAuctionStyleEndVehicle } from 'components/card/Buyers/Helpers';
import { VEHICLE_STATUS } from 'constants/vehicle';
import { deal_working, ended, live_or_extended, sold } from 'helpers/timedSales/auctionStatusScenarios';
import { calculateBackendDrivenSummaryFromList } from './backendDrivenOfferSummary';

export const isCurrentUserTheTopOfferer = ({ topOffererDealershipId, dealershipsId }) => {
	return topOffererDealershipId && dealershipsId.includes(topOffererDealershipId);
};

const isAuctionEngineVehicle = (bidSale) => Boolean(bidSale?.ae_auction_id);

const calculateSummaryForAuctionItem = (
	{ leaderCount, outbiddedCount, wonCount, lostCount, counterCount },
	isUserTheTopOfferer,
	bidSale,
) => {
	if (bidSale.status === VEHICLE_STATUS.expired) {
		lostCount++;
	} else if (live_or_extended(bidSale.auction_status)) {
		if (deal_working(bidSale.auction_status)) {
			if (isUserTheTopOfferer) {
				counterCount++;
			} else {
				if (isAuctionStyleEndVehicle(bidSale) && bidSale.acceptable_counter_offer_activity) {
					counterCount++;
				} else {
					isAuctionEngineVehicle(bidSale) || isAuctionStyleEndVehicle(bidSale) ?
						outbiddedCount++
					:	lostCount++;
				}
			}
		} else {
			if (isAuctionStyleEndVehicle(bidSale) && bidSale.acceptable_counter_offer_activity) {
				counterCount++;
			} else {
				isUserTheTopOfferer ? leaderCount++ : outbiddedCount++;
			}
		}
	} else if (sold(bidSale.auction_status) || ended(bidSale.auction_status)) {
		isUserTheTopOfferer ? wonCount++ : lostCount++;
	}

	return { leaderCount, outbiddedCount, wonCount, lostCount, counterCount };
};

const calculateSummaryForMarketplaceItem = (
	{ leaderCount, outbiddedCount, wonCount, lostCount, counterCount },
	isUserTheTopOfferer,
	bidSale,
) => {
	if (bidSale.status === VEHICLE_STATUS.expired) {
		lostCount++;
	} else if (bidSale.status === VEHICLE_STATUS.sold) {
		isUserTheTopOfferer ? wonCount++ : lostCount++;
	} else if (bidSale.status === VEHICLE_STATUS.active) {
		if (Boolean(bidSale.acceptable_counter_offer_activity)) {
			counterCount++;
		} else {
			isUserTheTopOfferer ? leaderCount++ : outbiddedCount++;
		}
	}

	return { leaderCount, outbiddedCount, wonCount, lostCount, counterCount };
};

const initialSummaryStats = {
	leaderCount: 0,
	outbiddedCount: 0,
	wonCount: 0,
	lostCount: 0,
	counterCount: 0,
};

const calculateLegacySummaryFromList = ({ bidSalesThatUserHasOfferer, dealershipsId }) => {
	return bidSalesThatUserHasOfferer.reduce(
		({ leaderCount, outbiddedCount, wonCount, lostCount, counterCount }, bidSale) => {
			const { top_offerer_dealership_id: topOffererDealershipId } = bidSale;
			const isUserTheTopOfferer = isCurrentUserTheTopOfferer({
				topOffererDealershipId,
				dealershipsId,
			});

			const calcMethod =
				bidSale.auction_status ? calculateSummaryForAuctionItem : calculateSummaryForMarketplaceItem;
			return calcMethod(
				{ leaderCount, outbiddedCount, wonCount, lostCount, counterCount },
				isUserTheTopOfferer,
				bidSale,
			);
		},
		initialSummaryStats,
	);
};

export const calculateSummaryFromList = ({ bidSalesThatUserHasOfferer, dealershipsId, isLegacyFormat }) => {
	if (!isLegacyFormat) {
		return calculateBackendDrivenSummaryFromList({ bidSalesThatUserHasOfferer });
	}

	return calculateLegacySummaryFromList({ bidSalesThatUserHasOfferer, dealershipsId });
};

export const getBidSalesIdDataForWebsockets = ({
	bidSalesArr,
	existingBidSaleIdsToMerge = [],
	existingDealershipIdByBidSaleIdToMerge = {},
}) => {
	const offerSummaryBidSaleIds = bidSalesArr.map((bidSale) => bidSale.bid_sale_id);
	const offererDealershipIdByBidSaleId = bidSalesArr.reduce((acc, bidSale) => {
		acc[bidSale.bid_sale_id] = bidSale.offerer_dealership_id;
		return acc;
	}, {});

	return {
		offerSummaryBidSaleIds: [...existingBidSaleIdsToMerge, ...offerSummaryBidSaleIds],
		offererDealershipIdByBidSaleId: {
			...existingDealershipIdByBidSaleIdToMerge,
			...offererDealershipIdByBidSaleId,
		},
	};
};
